var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Earn_icon",
    "data-name": "Earn icon",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1981.269,25.646a.661.661,0,0,1-.661-.66V23.093c-2.775-.6-4.725-2.46-4.767-5.286h3.966a2.534,2.534,0,0,0,2.8,2.46c1.745,0,2.776-.926,2.776-2.248,0-3.992-9.52-1.586-9.494-8.276,0-2.781,1.879-4.641,4.715-5.18v-1.8a.662.662,0,0,1,.661-.662h2.787a.662.662,0,0,1,.661.662V4.678a5.339,5.339,0,0,1,4.291,4.985h-4.072a2.437,2.437,0,0,0-2.644-2.2c-1.454-.052-2.538.662-2.538,2.169,0,3.7,9.466,1.639,9.466,8.144a5.453,5.453,0,0,1-4.5,5.3v1.9a.661.661,0,0,1-.661.66Z",
    transform: "translate(-1966.664 1.999)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.9f0305dc.svg";
export { ForwardRef as ReactComponent };